import React, { Component } from "react";
import { connect } from "react-redux";
import "./style.css";
import "../../../../../../../index.css";
import { actions as subject2schoolFilterActions } from "../../../../../../../redux/modules/subject2schoolfilter";
let levelMarkArray = [];
let tagMarkArray = [];
let propertyMarkArray = [];
let provinceMarkArray = [];
let limitMarkArray = [];
// 保存选中按钮的id
let levelData = [];
let tagData = [];
let propertyData = [];
let provinceData = [];
let limitData = [];
/**
 * 用于选科查询院校的筛选组件的子组件
 */
class SchoolFilterGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    limitMarkArray = this.props.markArray.limitMarkArray;
    levelMarkArray = this.props.markArray.levelMarkArray;
    tagMarkArray = this.props.markArray.tagMarkArray;
    propertyMarkArray = this.props.markArray.propertyMarkArray;
    provinceMarkArray = this.props.markArray.provinceMarkArray;
    // 调用父组件方法把当前实例传给父组件
    this.props.onRef("schoolFilterGroup", this);
  }
  render() {
    const { name, filters } = this.props;
    const {
      limitMarkArray,
      levelMarkArray,
      tagMarkArray,
      propertyMarkArray,
      provinceMarkArray,
    } = this.props.markArray;
    return (
      <div
        className={
          name === "选科限制"
            ? "subject2school_filter_gbox major_top_6"
            : "subject2school_filter_gbox major_top_25"
        }
      >
        <div>{name === "高校层次" ? "培养层次" : name}</div>
        <div className="subject2school_filter_gbox_f">
          {filters.map((item, index) => {
            if (name === "选科限制") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: limitMarkArray[index] ? "#ffeae0" : "",
                    color: limitMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl subject2school_filter_gbox_fd major_left_0"
                      : "fl subject2school_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: limitMarkArray[index] ? "block" : "none",
                    }}
                    className="subject2school_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "高校层次") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: levelMarkArray[index] ? "#ffeae0" : "",
                    color: levelMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl subject2school_filter_gbox_fd major_left_0"
                      : "fl subject2school_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: levelMarkArray[index] ? "block" : "none",
                    }}
                    className="subject2school_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "高校标签") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: tagMarkArray[index] ? "#ffeae0" : "",
                    color: tagMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl subject2school_filter_gbox_fd major_left_0"
                      : "fl subject2school_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: tagMarkArray[index] ? "block" : "none",
                    }}
                    className="subject2school_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "办学性质") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: propertyMarkArray[index] ? "#ffeae0" : "",
                    color: propertyMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl subject2school_filter_gbox_fd major_left_0"
                      : "fl subject2school_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: propertyMarkArray[index] ? "block" : "none",
                    }}
                    className="subject2school_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "地区") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: provinceMarkArray[index] ? "#ffeae0" : "",
                    color: provinceMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl subject2school_filter_gbox_fd major_left_0"
                      : "fl subject2school_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: provinceMarkArray[index] ? "block" : "none",
                    }}
                    className="subject2school_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            return <div></div>;
          })}
          <div className="clear"></div>
        </div>
      </div>
    );
  }

  /**
   * 选中过滤条件
   */
  handleSelectFilter = (index, id, name) => {
    var arr;
    const { dispatch } = this.props;
    switch (name) {
      case "选科限制": {
        limitMarkArray[index] = limitMarkArray[index] === 1 ? 0 : 1;
        dispatch(subject2schoolFilterActions.setLimitMarkArray(limitMarkArray));
        arr = this.handleArrary(id, limitMarkArray[index], limitData);
        dispatch(subject2schoolFilterActions.setLimitFilterId(arr));
        this.props.handleChangState({ limits: arr });
        break;
      }
      case "高校层次": {
        levelMarkArray[index] = levelMarkArray[index] === 1 ? 0 : 1;
        dispatch(subject2schoolFilterActions.setLevelMarkArray(levelMarkArray));
        arr = this.handleArrary(id, levelMarkArray[index], levelData);
        dispatch(subject2schoolFilterActions.setLevelFilterId(arr));
        this.props.handleChangState({ schoolLevelIds: arr });
        break;
      }
      case "高校标签": {
        tagMarkArray[index] = tagMarkArray[index] === 1 ? 0 : 1;
        dispatch(subject2schoolFilterActions.setTagMarkArray(tagMarkArray));
        arr = this.handleArrary(id, tagMarkArray[index], tagData);
        dispatch(subject2schoolFilterActions.setTagFilterId(arr));
        this.props.handleChangState({ schoolTagIds: arr });
        break;
      }
      case "办学性质": {
        propertyMarkArray[index] = propertyMarkArray[index] === 1 ? 0 : 1;
        dispatch(
          subject2schoolFilterActions.setPropertyMarkArray(propertyMarkArray)
        );
        arr = this.handleArrary(id, propertyMarkArray[index], propertyData);
        dispatch(subject2schoolFilterActions.setPropertyFilterId(arr));
        this.props.handleChangState({ schoolPropertyIds: arr });
        break;
      }
      case "地区": {
        provinceMarkArray[index] = provinceMarkArray[index] === 1 ? 0 : 1;
        dispatch(
          subject2schoolFilterActions.setProvinceMarkArray(provinceMarkArray)
        );
        arr = this.handleArrary(id, provinceMarkArray[index], provinceData);
        dispatch(subject2schoolFilterActions.setProvinceFilterId(arr));
        this.props.handleChangState({ provinceIds: arr });
        break;
      }
      default: {
        break;
      }
    }
  };
  /**
   * 处理数组
   */
  handleArrary = (id, status, data) => {
    if (status === 1) {
      data.push(id);
    } else {
      this.handleRemove(id, data);
    }
    return data;
  };

  /**
   * 删除指定数组元素
   */
  handleRemove = (val, data) => {
    var index = this.getIndexOf(val, data);
    if (index > -1) {
      data.splice(index, 1);
    }
  };
  //获取元素在数组的下标
  getIndexOf = function (val, data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i] === val) {
        return i;
      }
    }
    return -1;
  };
  /**
   * 重置ui状态以及过滤条件
   */
  resetUIState = () => {
    const { dispatch } = this.props;
    for (let i = 0; i < limitMarkArray.length; i++) {
      limitMarkArray[i] = 0;
    }
    dispatch(subject2schoolFilterActions.setLimitMarkArray(limitMarkArray));
    dispatch(subject2schoolFilterActions.setLimitFilterId([]));
    limitData = [];
    for (let i = 0; i < levelMarkArray.length; i++) {
      levelMarkArray[i] = 0;
    }
    dispatch(subject2schoolFilterActions.setLevelMarkArray(levelMarkArray));
    dispatch(subject2schoolFilterActions.setLevelFilterId([]));
    levelData = [];
    for (let i = 0; i < tagMarkArray.length; i++) {
      tagMarkArray[i] = 0;
    }
    dispatch(subject2schoolFilterActions.setTagMarkArray(tagMarkArray));
    dispatch(subject2schoolFilterActions.setTagFilterId([]));
    tagData = [];
    for (let i = 0; i < propertyMarkArray.length; i++) {
      propertyMarkArray[i] = 0;
    }
    dispatch(
      subject2schoolFilterActions.setPropertyMarkArray(propertyMarkArray)
    );
    dispatch(subject2schoolFilterActions.setPropertyFilterId([]));
    propertyData = [];
    for (let i = 0; i < provinceMarkArray.length; i++) {
      provinceMarkArray[i] = 0;
    }
    dispatch(
      subject2schoolFilterActions.setProvinceMarkArray(provinceMarkArray)
    );
    dispatch(subject2schoolFilterActions.setProvinceFilterId([]));
    provinceData = [];
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.subject2schoolfilter.schoolFilterData,
    markArray: state.subject2schoolfilter.schoolMarkArrayData,
  };
};
export default connect(mapStateToProps)(SchoolFilterGroup);



// WEBPACK FOOTER //
// ./src/containers/SubjectQuerySchool/SchoolList/components/SchoolFilter/components/SchoolFilterGroup/index.js